import React from 'react';
import Modal from 'react-modal';

export default function AddDocumentTaskModal(props) {

    if (props.close, props.value, props.open) {
        return (
            <Modal
                isOpen={props.value}
                onRequestClose={props.close}
                className="custom-modal-sm border"
                overlayClassName="custom-modal-overlay"
                contentLabel="Add new user to team"
            >

                <div className="container-fluid bg-light border-bottom">
                    <div className="row">
                        <div className="col-9">
                            <h4 className="mt-2">Добавяне на нова задача</h4>
                        </div>
                        <div className="col-3">
                            <button type="button" className="close p-2" onClick={props.close}>
                                <span>&times;</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row py-2 bg-light">
                        <div className="col-12">
                            <form>
                                <div className="form-group">
                                    <label>Име на потребителя</label>
                                    <input type="text" defaultValue={`Име Презиме Фамилия`} disabled={true} className="form-control" />
                                </div>
                                <div className="form-group">
                                    <label>E-mail адрес</label>
                                    <input type="email" defaultValue={`usermail@mail.bg`} disabled={true} className="form-control" />
                                </div>
                                <div className="form-group">
                                    <label>Кратко описание</label>
                                    <input type="text" className="form-control" />
                                </div>
                                <div className="form-group">
                                <label>Подробно описание</label>
                                <textarea class="form-control" rows="3"></textarea>
                                </div>
                                <div className="form-group form-check row">
                                    <div className="col-12">
                                        <input type="checkbox" class="form-check-input" id="attachmentLink" />
                                        <label class="form-check-label" htmlFor="attachmentLink">Прикачи като линк</label>
                                    </div>
                                    <div className="col-12">
                                        <input type="checkbox" class="form-check-input" id="attachmentPDF" />
                                        <label class="form-check-label" htmlFor="attachmentPDF">Прикачи като PDF</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-12">
                                        <label className="mb-0">Срок за изпълнение</label>
                                    </div>
                                    <div className="col-6">
                                        <label>Дата</label>
                                        <input type="date" className="form-control" />
                                    </div>
                                    <div className="col-6">
                                        <label>Час</label>
                                        <input type="text" className="form-control" />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <button type="submit" className="btn btn-primary float-right">Създай задача</button>
                                    <button type="button" onClick={props.close} className="btn btn-danger float-right mr-2">Отказ</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </ Modal>
        );
    }
}